import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Alert } from 'react-bootstrap';
import { IEmployee } from '../model/Employee.model';
import { RatingBox } from '../../../common/components/rating-box';
import { CSEmployeeRole } from './employee-role';
import { CSEmployeeType } from './employee-type';

interface IProps {
  employee: IEmployee;
}

export const EmployeePopover: React.FC<IProps> = ({ employee }) => {
  const image = employee.smallAvatar ? getImage(employee.smallAvatar) : null;
  const employeeType = employee.type
    .toString()
    .split(',')
    .map((type, index) => <CSEmployeeType type={type} key={index} />);
  return (
    <div className="employee-popover">
      <div className="top">
        <div className={`avatar ${employee.rarityClassName}`}>
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${employee.fullName}`}
            />
          )}
        </div>
        <p className="name">
          <span className="emp-name">{employee.shortName}</span>{' '}
          {employee.showNewTag && <span className="tag new">NEW!</span>}{' '}
          {employee.hasBeenBuffedRecently && (
            <span className="tag buffed">Updated</span>
          )}
        </p>
        <div className="type-class">
          <CSEmployeeRole role={employee.role} />
          {employeeType}
          {employee.isRearmed === true && <CSEmployeeRole role="Rearm" />}
        </div>
      </div>
      {!employee.isRatingPending ? (
        <>
          <div className="bottom">
            <RatingBox
              game="cs"
              rating={employee.newRatings.pve_early}
              ratingName="PVE (Early)"
            />
            <RatingBox
              game="cs"
              rating={employee.newRatings.pve_late}
              ratingName="PVE (Late)"
            />
            <RatingBox
              game="cs"
              rating={employee.newRatings.pvp_sea}
              ratingName="PVP"
            />
          </div>
        </>
      ) : (
        <Alert variant="primary">
          <p>
            This employee was recently released in KR and we need time to
            properly test his/her abilities before reviewing and rating him/her.
          </p>
        </Alert>
      )}
    </div>
  );
};
